export default "__VITE_ASSET__CHW1CgUC__"